const KEY = 'capsico:customer:device';

/**
 * A random id for this phone / browser, created once. It is not a secret: it only lets the
 * server recognise the device (new-device alerts, one session per device).
 */
export function deviceId(): string {
  try {
    const stored = window.localStorage.getItem(KEY);
    if (stored && /^[A-Za-z0-9_-]{16,64}$/.test(stored)) return stored;
    const fresh = crypto.randomUUID().replace(/-/g, '');
    window.localStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    return crypto.randomUUID().replace(/-/g, '');
  }
}
